// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"f40efbc8","304":"950f7803","335":"d92876b6","568":"9bb81f70","642":"1187e72c"}[chunkId] + ".chunk.js";
};